import styled from "@emotion/styled";
import { ReactComponent as ApplicationLogo } from "assets/images/svg/applications.svg";

export const UploadImage = styled("div")`
  height: 100px;
  width: 120px;
  backdrop-filter: blur(2px);
  border: ${(props) =>
    props.isDisabled ? "1px dashed #dddddd" : "1px dashed black"};
  background-color: rgba(255, 255, 255, 0.5);
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const ApplicationIcon = styled(ApplicationLogo)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
    `
);
